// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1404":"7768f6651fdc59c6","38269":"d66681522779ae79","48083":"dc3b640fa1af1fa7"}[chunkId] + ".js";
};